import { render, staticRenderFns } from "./ModalArea.vue?vue&type=template&id=2bd7f6bd"
import script from "./ModalArea.vue?vue&type=script&lang=js"
export * from "./ModalArea.vue?vue&type=script&lang=js"
import style0 from "./ModalArea.vue?vue&type=style&index=0&id=2bd7f6bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports